import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import BlogPage from "@/pages/BlogPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import ResourcesPage from "@/pages/ResourcesPage";
import CoursePage from "@/pages/CoursePage";
import BlogPostPage from "@/pages/BlogPostPage";
import BetaApplyPage from "@/pages/BetaApplyPage";
import AdminPage from "@/pages/AdminPage";
import ToolkitPage from "@/pages/ToolkitPage";
import KitContentPage from "@/pages/KitContentPage";
import ShopPage from "@/pages/ShopPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen" style={{ background: 'var(--ll-bg)' }}>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:postId" element={<BlogPostPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment/cancel" element={<PaymentCancelPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/course" element={<CoursePage />} />
          <Route path="/beta" element={<BetaApplyPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/toolkit" element={<ToolkitPage />} />
          <Route path="/kit/:kitId" element={<KitContentPage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
